(() => {
  const STYLE_ID = 'bap-fit-size-inline-style';
  const MIRROR_CLASS = 'bap-fit-size-inline-mirror';
  let observer;
  let scheduled = false;

  const injectInlineStyle = () => {
    if (document.getElementById(STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      .shopify-section--main-product .baporssa-variant-option .variant-picker__option-info,
      .shopify-section--main-product .variant-picker__option .variant-picker__option-info {
        align-items: center !important;
        gap: 12px !important;
      }

      .shopify-section--main-product .baporssa-variant-option--color .variant-picker__option-info,
      .shopify-section--main-product .variant-picker__option:first-child .variant-picker__option-info {
        display: flex !important;
        justify-content: space-between !important;
      }

      .shopify-section--main-product .product-info__block-item[data-block-type="size-guide-popup"] {
        margin-block: 0 !important;
      }

      .shopify-section--main-product .product-info__block-item[data-block-type="size-guide-popup"] > bap-fit-size-module > .bap-fit-size__trigger {
        display: none !important;
      }

      .shopify-section--main-product .${MIRROR_CLASS} {
        appearance: none !important;
        display: inline-flex !important;
        align-items: center !important;
        justify-content: flex-end !important;
        width: auto !important;
        min-width: 0 !important;
        min-height: auto !important;
        margin-inline-start: auto !important;
        padding: 0 !important;
        border: 0 !important;
        border-radius: 0 !important;
        background: transparent !important;
        box-shadow: none !important;
        color: rgb(var(--text-color) / 0.68) !important;
        font: inherit !important;
        cursor: pointer !important;
        text-align: right !important;
        white-space: nowrap !important;
      }

      .shopify-section--main-product .${MIRROR_CLASS}:hover,
      .shopify-section--main-product .${MIRROR_CLASS}:focus-visible {
        color: rgb(var(--text-color)) !important;
      }

      .shopify-section--main-product .${MIRROR_CLASS}__label {
        display: inline-block !important;
        font-size: var(--text-xs) !important;
        line-height: 1.3 !important;
        font-weight: 650 !important;
        letter-spacing: 0.02em !important;
        text-transform: none !important;
        text-decoration: underline !important;
        text-underline-offset: 3px !important;
      }

      @media screen and (max-width: 699px) {
        .shopify-section--main-product .baporssa-variant-option .variant-picker__option-info,
        .shopify-section--main-product .variant-picker__option .variant-picker__option-info {
          gap: 10px !important;
        }

        .shopify-section--main-product .${MIRROR_CLASS}__label {
          font-size: 11px !important;
        }
      }
    `;

    document.head.appendChild(style);
  };

  const findSourceModule = () => {
    return document.querySelector('.shopify-section--main-product .product-info__block-item[data-block-type="size-guide-popup"] bap-fit-size-module')
      || document.querySelector('.shopify-section--main-product bap-fit-size-module[data-fit-module]');
  };

  const findSourceTrigger = () => {
    const sourceModule = findSourceModule();
    return sourceModule?.querySelector('[data-fit-open]');
  };

  const findInlineTarget = () => {
    return document.querySelector('.shopify-section--main-product .baporssa-variant-option--color .variant-picker__option-info')
      || document.querySelector('.shopify-section--main-product .variant-picker__option:first-child .variant-picker__option-info')
      || document.querySelector('.shopify-section--main-product .variant-picker__option .variant-picker__option-info');
  };

  const getLabel = () => {
    const sourceTrigger = findSourceTrigger();
    return sourceTrigger?.querySelector('.bap-fit-size__trigger-label')?.textContent?.trim()
      || sourceTrigger?.textContent?.trim()
      || 'Fit & Size';
  };

  const removeDuplicateMirrors = (keep) => {
    document.querySelectorAll(`.${MIRROR_CLASS}`).forEach((mirror) => {
      if (mirror !== keep) mirror.remove();
    });
  };

  const openSourceModule = () => {
    const sourceTrigger = findSourceTrigger();

    if (!sourceTrigger) {
      scheduleMount();
      return;
    }

    sourceTrigger.click();
  };

  const createMirror = () => {
    const mirror = document.createElement('button');
    mirror.type = 'button';
    mirror.className = MIRROR_CLASS;
    mirror.setAttribute('aria-label', 'Open fit and size guide');
    mirror.innerHTML = `<span class="${MIRROR_CLASS}__label"></span>`;
    mirror.addEventListener('click', openSourceModule);
    return mirror;
  };

  const mountFitSizeMirror = () => {
    injectInlineStyle();

    const sourceModule = findSourceModule();
    const inlineTarget = findInlineTarget();

    if (!sourceModule || !inlineTarget) {
      return;
    }

    sourceModule.classList.remove('bap-fit-size--inline');
    sourceModule.dataset.mounted = 'source';

    let mirror = inlineTarget.querySelector(`:scope > .${MIRROR_CLASS}`);

    if (!mirror) {
      mirror = createMirror();
      inlineTarget.append(mirror);
    }

    const label = mirror.querySelector(`.${MIRROR_CLASS}__label`);
    if (label) label.textContent = getLabel();

    const sourceDialog = sourceModule.querySelector('[data-fit-dialog]');
    if (sourceDialog?.id) mirror.setAttribute('aria-controls', sourceDialog.id);

    removeDuplicateMirrors(mirror);
  };

  const scheduleMount = () => {
    if (scheduled) return;
    scheduled = true;

    window.requestAnimationFrame(() => {
      scheduled = false;
      mountFitSizeMirror();
    });
  };

  const startObserver = () => {
    if (observer) return;

    const root = document.querySelector('.shopify-section--main-product');
    if (!root) return;

    observer = new MutationObserver(scheduleMount);
    observer.observe(root, { childList: true, subtree: true });
  };

  const boot = () => {
    mountFitSizeMirror();
    startObserver();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', () => {
    observer?.disconnect();
    observer = undefined;
    boot();
  });
  document.addEventListener('shopify:block:select', scheduleMount);
  document.addEventListener('variant:change', scheduleMount);
  document.addEventListener('product:rerender', scheduleMount);
})();
